import React from 'react'
import { PageHeader } from '../PageHeader/PageHeader'
import cont from './Contact.module.css'

const contact = [
    {
        image : 'https://img.icons8.com/windows/256/4a90e2/github.png',
        link : 'https://github.com/sy3dyaseen'
    },
    {
        image : 'https://img.icons8.com/fluency/240/000000/linkedin-2.png',
        link : 'https://www.linkedin.com/in/syed-yaseen1996'
    }
]

const Contact = () => {
    return (
        <div className={cont.contacts} id='contact'>
            <PageHeader title={'Contact Me'} />
            <div className={cont.call}>
                <div>
                <a className={cont.numMail} href="tel:+9686760965">9686760965</a> 
                </div>
               
                <div>
                <a className={cont.numMail} href='mailto: sy3dyaseen@gmail.com'>
              sy3dyaseen@gmail.com
            </a>
                </div> 
            </div>
            <br />
            <div className={cont.icons}>
                { 
                    contact.map(({ image, link }) => {

                        return (
                            <>
                            <a href={link} target="_blank">
                                <img style={{height:'40px'}} src={image} alt="propic" />
                            </a>
                            </>
                        )
                    })
                }
            </div>
            
        </div>
    )
}

export {Contact}
